import esCL from './locales/es-CL'
import ptBR from './locales/pt-BR'

export const resources = {
  'pt-BR': ptBR,
  'es-CL': esCL,
} as const
